import { render } from "./ModalDrawer.vue?vue&type=template&id=650e6d55&scoped=true"
import script from "./ModalDrawer.vue?vue&type=script&lang=js"
export * from "./ModalDrawer.vue?vue&type=script&lang=js"

import "./ModalDrawer.vue?vue&type=style&index=0&id=650e6d55&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650e6d55"]])

export default __exports__